<template>
  <div>
    <v-dialog
      v-model="dialog_chart_setting"
      scrollable
      persistent
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card>
        <!-- <pre>{{all_chart_report}}</pre> -->
        <v-card-title primary-title style="background-color:rgba(227, 236, 238, 0.9);">
          ตั้งค่ากราฟรายงานประจำเดือนยอดบริการ
          <v-spacer></v-spacer>
          <v-btn icon class="float-right" @click="dialog_chart_setting = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card
            class="pt-2 my-3 mt-6"
            outlined
            v-for="(chart,n) in all_chart_report"
            :key="chart.monthly_service_reports_type_id"
            :color="n%2!=0?'rgba(227, 236, 238, 0.3)':''"
          >
            <v-card-title class="justify-center main-title py-2">
              {{chart.monthly_service_reports_type_name}}
              <v-spacer></v-spacer>
              <v-btn
                v-if="edited_index==n?false:true"
                color="secondary"
                class="float-right"
                icon
                @click="EditValue(chart,n);edited_index = n"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-if="show_save&& edited_index==n"
                color="primary"
                class="float-right"
                icon
                type="submit"
                @click="putReviceReport(n,chart.monthly_service_reports_type_id)"
              >
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
              <v-btn
                v-if="show_save&& edited_index==n"
                color="error"
                class="float-right"
                icon
                @click="deleteReviceReport(chart.monthly_service_reports_type_id)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card-title>
            <!-- <pre>  {{chart_value[0]}}</pre> -->
            <v-card-text>
              <v-row class="px-8">
                <v-col cols="2" v-for="(value_chart,i) in chart_value[n]" :key="i">
                  <v-text-field
                    v-model="value_chart.value"
                    :label="month_name[i]"
                    outlined
                    type="number"
                    :rules="rule_field_is_empty"
                    :disabled="value_chart.disable"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      header_token: {
        headers: { Authorization: "Bearer " + this.$session.get("token") },
      },
      value_mode: true,
      select_items: 0,
      dialog_chart_setting: false,
      dialog: false,
      rule_field_is_empty: [
        (v) => !!v || "กรุณากรอกข้อมูล",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      value: [],
      all_chart_report: [],
      edited_index: -1,
      chart_value: [],
      show_save: false,
      month_name: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  created() {
    this.getChartReport();
  },
  methods: {
    getChartReport() {
      let chart_report = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/monthly_revice_report")
        .then((response) => {
          // console.log(response.data);
          chart_report = response.data;
          this.all_chart_report = chart_report;
        });
    },
    EditValue(chart, n) {
      // console.log(n);
      var date = new Date().toISOString().substr(0, 10);
      var month = date.split("-")[1];
      this.show_save = true;
      var data = chart.data;
      this.all_chart_report.forEach((element, index) => {
        this.chart_value.push([]);
        if (index == n) {
          element.data.forEach((chart, i) => {
            // console.log(chart);
            if (i + 1 > parseInt(month) - 1) {
              this.chart_value[index].push({ value: 0, disable: true });
            } else {
              this.chart_value[index].push({ value: chart, disable: false });
            }
          });
        } else {
          this.chart_value[this.edited_index] == [];
          // element.data.forEach(chart => {
          this.chart_value[index].splice(0, 12);
          // });
        }
      });
    },
    openSetting() {
      this.chart_value = [];
      this.value_chart = [];
      this.edited_index = -1;
      this.dialog_chart_setting = true;
    },

    close() {
      this.dialog = false;
      // this.clear();
    },
    putReviceReport(id, put_id) {
      let value_data = [];
      // console.log(id);

      this.chart_value[id].forEach((element) => {
        value_data.push(element.value);
      });
      let data = { data: value_data };
      this.axios
        .put(
          process.env.VUE_APP_API + "/api/v1/monthly_revice_report/" + put_id,
          data,
          this.header_token
        )
        .then((response) => {
          if (response.data == "update success") {
            this.$swal.fire({
              icon: "success",
              title: "แก้ไขข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.show_save = false;
            this.edited_index = -1;
            this.chart_value = [];
            this.getChartReport();
            this.$emit("getChart", "put");
          }
        });
    },

    deleteReviceReport(id) {
      let data = { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] };
      this.axios
        .put(
          process.env.VUE_APP_API + "/api/v1/monthly_revice_report/" + id,
          data,
          this.header_token
        )
        .then((response) => {
          // console.log(response.data);

          if (response.data == "update success") {
            this.$swal.fire({
              icon: "success",
              title: "ลบข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.show_save = false;

            this.edited_index = -1;
            this.chart_value = [];
            this.getChartReport();
            this.$emit("getChart", "delete");
          }
        });
    },
  },
};
</script>